/**
 * Corporacao recem-cadastrada, ainda sem as tabelas do hdocs: a API responde 503 com `codigo: corporacao_em_preparo` (ExigeCorporacaoPreparada,
 * no hdocs-api) em vez de um erro de banco, e a tela mostra uma pagina de espera. Aqui fica so o que se decide sem Vue, para dar para testar.
 */

export const CODIGO_EM_PREPARO = 'corporacao_em_preparo';

/** De quanto em quanto tempo a tela de espera pergunta se ja da para entrar, se a API nao disser (e dentro destes limites se disser). */
export const SEGUNDOS_PADRAO = 15;
const MINIMO = 5;
const MAXIMO = 120;

/** O erro e o aviso "estamos preparando a sua empresa"? Um 503 qualquer (API fora do ar, por exemplo) NAO e: so o que traz o codigo. */
export function ehCorporacaoEmPreparo(erro) {
    return erro?.response?.status === 503 && erro.response?.data?.codigo === CODIGO_EM_PREPARO;
}

/** Em quantos segundos perguntar de novo: o que a API pediu, limitado a 5-120 (um valor absurdo nao pode travar nem sobrecarregar a tela). */
export function segundosParaTentar(erro) {
    const pedido = Number(erro?.response?.data?.tentar_novamente_em);

    if (!Number.isFinite(pedido) || pedido <= 0) return SEGUNDOS_PADRAO;

    return Math.min(MAXIMO, Math.max(MINIMO, Math.round(pedido)));
}
